import React, { memo } from 'react';
import { ReportType, ClientCustomCalendarModel } from '../../../../models';
import ReportDateSettingDeleteBalance from './DeleteBalance';
import ReportDateSettingRollforward from './Rollforward';
import ReportDateSettingMaturity from './Maturity';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import { ReportSettingState } from '../index';
import ReportDateSettingCommitment from './Commitment';
import ReportDateSettingPercentageRent from './PercentageRent';
import ReportDateSettingFiscalRollforward from './FiscalRollforward';
import ReportDateSettingStartEnd from './StartEnd';
import ReportDateSettingSublease from './Sublease';
import ReportDateSettingWeightedAverage from './WeightedAverage';
import ReportDateSettingDisclosure from './Disclosure';
import ReportDateSettingFromTo from './FromTo';
import ReportDateSettingLeaseCommitment from './LeaseCommitment';
import ReportDateSettingAssetAmort from './AssetAmort';
import ReportDateSettingPAndL from './PAndL';
import ReportDateSettingAP from './AP';
import ReportDateSettingCustom from './Custom';
import ReportDateSettingROUAssets from './ROUAssets';
import { ReportDateSettingsWrapper } from '../styled/ReportDateSettingsWrapper.styled';

interface ReportSettingProps {
  reportType?: ReportType;
  onChange?: (reportSetting: ReportSettingState) => void;
  reportSettingState: ReportSettingState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowSplitByAllocationForReport?: boolean;
  children?: JSX.Element;
}

const ReportSettingComponents = {
  [ReportType.custom]: ReportDateSettingCustom,
  [ReportType.rollforward]: ReportDateSettingRollforward,
  [ReportType.maturity]: ReportDateSettingMaturity,
  [ReportType.deleteBalance]: ReportDateSettingDeleteBalance,
  [ReportType.committment]: ReportDateSettingCommitment,
  [ReportType.fiscalRollforward]: ReportDateSettingFiscalRollforward,
  [ReportType.percentageRent]: ReportDateSettingPercentageRent,
  [ReportType.startEnd]: ReportDateSettingStartEnd,
  [ReportType.sublease]: ReportDateSettingSublease,
  [ReportType.weightedAverage]: ReportDateSettingWeightedAverage,
  [ReportType.disclosure]: ReportDateSettingDisclosure,
  [ReportType.fromTo]: ReportDateSettingFromTo,
  [ReportType.leaseCommittment]: ReportDateSettingLeaseCommitment,
  [ReportType.assetAmort]: ReportDateSettingAssetAmort,
  [ReportType.effectOfStandardAdoptionPAndL]: ReportDateSettingPAndL,
  [ReportType.ap]: ReportDateSettingAP,
  [ReportType.rouAssets]: ReportDateSettingROUAssets,
};

type Props = {
  onChange: (updatedValue: ReportSettingState) => void;
  reportSettingState: ReportSettingState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings: ClientCustomCalendarModel;
};

const renderReportSettingByType = (
  reportType: ReportType,
  reportSettingState: ReportSettingState,
  reportTypeSetting: ReportTypeSetting,
  isAllowPIT: boolean,
  isAllowSplitByAllocationForReport?: boolean,
  onChange?: (reportSetting: ReportSettingState) => void,
  customCalendarSettings?: ClientCustomCalendarModel,
): JSX.Element => {
  const ReportSettingComponent = ReportSettingComponents[
    reportType
  ] as React.ComponentType<Props>;
  const props = {
    reportSettingState,
    reportTypeSetting,
    isAllowPIT,
    isAllowSplitByAllocationForReport,
    onChange,
    customCalendarSettings,
  };
  return <ReportSettingComponent {...props} />;
};

function ReportDateSetting({
  reportType,
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  isAllowSplitByAllocationForReport = false,
  customCalendarSettings,
  children,
}: ReportSettingProps): JSX.Element {
  return (
    <>
      <ReportDateSettingsWrapper>
        {renderReportSettingByType(
          reportType,
          reportSettingState,
          reportTypeSetting,
          isAllowPIT,
          isAllowSplitByAllocationForReport,
          onChange,
          customCalendarSettings,
        )}
        {children}
      </ReportDateSettingsWrapper>
    </>
  );
}

export default memo(ReportDateSetting);
